const OtherList = () => {
  return (
    <div className="content-page-admin">
      <div className="title-page-admin">
        <i className="bx bx-list-ul"></i>
        <p>OtherList page</p>
      </div>
    </div>
  );
};

export default OtherList;
